import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../endpoints';
import { Quarry } from '../sites/quarries';
import { Site } from '../planning';
import { Machine } from '../materials/machines';
import { Tool } from '../materials/tools';
import { RentalType } from '../materials/rentalTypes';

export interface DailyTransferRide {
    _id: string;
    dailyTrucksRidesId: string;
    siteId?: Site;
    quarryId?: Quarry;
    machineId?: Machine;
    toolId?: Tool;
    rentalName?: string;
    rentalCompanyId?: RentalType;
    state: number;
}

export interface DailyTransfersRidesResponse {
    message: string;
    data: DailyTransferRide[];
}

export interface DailyTransferRideResponse {
    message: string;
    data: DailyTransferRide;
}

// GET All Daily TransfersRides
export const getAllDailyTransfersRides = async (): Promise<DailyTransfersRidesResponse> => {
    try {
        const response: AxiosResponse<DailyTransfersRidesResponse> = await apiClient.get('/daily-transfersrides');
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

// GET Daily TransfersRides by Daily Trucks Ride ID
export const getDailyTransfersRidesByTruckRideId = async (dailyTrucksRidesId: string): Promise<DailyTransfersRidesResponse> => {
    try {
        const response: AxiosResponse<DailyTransfersRidesResponse> = await apiClient.get('/daily-transfersrides/daily-trucksrides/' + dailyTrucksRidesId);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

// CREATE Daily TransferRide

export interface CreateDailyTransferRideBody {
    dailyTrucksRidesId: string;
    siteId?: string;
    quarryId?: string;
    machineId?: string;
    toolId?: string;
    rentalName?: string;
    rentalCompanyId?: string;
    state: number;
}

export const createDailyTransferRide = async (body: CreateDailyTransferRideBody): Promise<DailyTransferRideResponse> => {
    try {
        const response: AxiosResponse<DailyTransferRideResponse> = await apiClient.post('/daily-transfersrides', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

// UPDATE Daily TransferRide
export interface UpdateDailyTransferRideBody {
    dailyTrucksRidesId?: string;
    siteId?: string;
    quarryId?: string;
    machineId?: string;
    toolId?: string;
    rentalName?: string;
    rentalCompanyId?: string;
    state?: number;
}

export const updateDailyTransferRide = async (id: string, body: UpdateDailyTransferRideBody): Promise<DailyTransferRideResponse> => {
    try {
        const response: AxiosResponse<DailyTransferRideResponse> = await apiClient.patch('/daily-transfersrides/' + id, body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

// DELETE Daily TransferRide

export const deleteDailyTransferRide = async (id: string): Promise<DailyTransferRideResponse> => {
    try {
        const response: AxiosResponse<DailyTransferRideResponse> = await apiClient.delete('/daily-transfersrides/' + id);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
